import {
    GET_LIST,
    GET_TRENDING_LIST,
    CREATE_LIST,
    DELETE_LIST,
    SAVE_TO_LIST,
    PAGE_LOAD_ANALYTICS_ACTION,
    LOAD_TRENDING_ITEMS,
    RESET_LIST,
    COPY_LIST_SUCCESS_MSG,
    CLEAR_LIST_ERROR,
    SET_SYNC_ERRORS,
} from '../actionTypes/MyListActionTypes';

export const getLists = (data, headers) => ({
    type: GET_LIST,
    payload: { data },
    headers,
});

export const getTrendingLists = (id, headers) => ({
    type: GET_TRENDING_LIST,
    payload: { firstId: id },
    headers,
});

export const createList = (data) => ({
    type: CREATE_LIST,
    payload: data,
});

export const deleteList = (listId) => ({
    type: DELETE_LIST,
    payload: { listId },
});

export const clearListError = () => ({
    type: CLEAR_LIST_ERROR,
});

export const setListError = (error) => ({
    type: SET_SYNC_ERRORS,
    payload: error,
});

export const saveToList = (data) => ({
    type: SAVE_TO_LIST,
    payload: { params: data.data, listId: data.listId },
});

export const resetList = () => ({
    type: RESET_LIST,
    payload: { params: true },
});

export const myListAnalyticsAction = (data) => ({
    type: PAGE_LOAD_ANALYTICS_ACTION,
    payload: data,
});

export const loadTrendingItems = (queryParams, isSort) => ({
    type: LOAD_TRENDING_ITEMS,
    payload: { queryParams, isSort },
});

export const showCopyListSuccessMessage = (data) => ({
    type: COPY_LIST_SUCCESS_MSG,
    payload: data,
});

/**
 * Gift registry actions will be shifted to separate file once
 * we have more action types
 */
